import React, { Component } from "react";
import { connect } from "react-redux";
import { storeChangeObject } from "@action";
class voiceControl extends Component {
  render() {
    const { props } = this;

    return (
      <div>
        <img
          onClick={() =>
            props.dispatch(
              storeChangeObject({
                isPlayAudio: !props.isPlayAudio
              })
            )
          }
          src={
            props.isPlayAudio
              ? require("@img/audio_open.png")
              : require("@img/audio_close.png")
          }
          className={`contro_audio ${
            props.videoFullScreen
              ? this.props.isHuawei
                ? "add_ttop"
                : "add_top"
              : ""
          } ${props.isPlayAudio ? "active" : ""}`}
        />
      </div>
    );
  }
}
const mapStateToProps = state => {
  return state;
};
export default connect(mapStateToProps, null)(voiceControl);
